<template>
  <div class="container">
    <div class="left">
      <!-- left -->
    </div>
    <section class="section">
      <span class="floatRight" @click="toggleAccordion('Action')">
        <div
          v-if="openComp[0].visible === true && innerWidth <= 480"
          class="openSection"
          style="align-items: center; text-align: center;"
        >
          V
        </div>
        <div v-else-if="innerWidth <= 480" class="closedSection" 
          style="align-items: center; text-align: center;">
          >
        </div>
        <div v-else></div>
      </span>
        <h3 @click="toggleAccordion('Action')">What You Can Do</h3>
      <article class="article-content" :ref="'Action'">
        <p class="content-p">
          Consider tweeting this experience to local government officals, state congressional members and people of influence.
        </p>
      </article>
    </section>
    
    <section class="section1">
      <span class="floatRight" @click="toggleAccordion('Experience')">
        <div
          v-if="openComp[1].visible === true && innerWidth <= 480"
          class="openSection"
          style="align-items: center; text-align: center;"
        >
          V
        </div>
        <div v-else-if="innerWidth <= 480" class="closedSection" 
          style="align-items: center; text-align: center;">
          >
        </div>
        <div v-else></div>
      </span>
      <h3 @click="toggleAccordion('Experience')">Lack of Resources</h3>
      <article class="article-content" :ref="'Experience'">
        <p class="content-p">
          The main takeaway from sharing the experience of this app is for users to find themselves with a lack of resources.
        </p>
        <p class="content-p">
          For many, this is an all too common experience. Which as a result, contributes to many other issues in under served communities.
        </p>
      </article>
    </section>

    <div class="right">
      <!-- right -->
    </div>
    <section class="section2">
      <span class="floatRight" @click="toggleAccordion('Story')">
        <div
          v-if="openComp[2].visible === true && innerWidth <= 480"
          class="openSection"
          style="align-items: center; text-align: center;"
        >
          V
        </div>
        <div v-else-if="innerWidth <= 480" class="closedSection" 
          style="align-items: center; text-align: center;">
          >
        </div>
        <div v-else></div>
      </span>
        <h3 @click="toggleAccordion('Story')">Story Time</h3>
      <article class="article-content" :ref="'Story'">
        <p class="content-p">
          This app was born out directly from the experience of trying to secure internet service for my family during the COVID-19 Pandemic.
        </p>
        <p class="content-p"> github repo will be public soon </p>
        <!-- <p class="content-p" style="width:75%;">
          I discovered after searching for over several weeks that consistent internet service does not exist in my area.
          This lead to learning more about cellular internet service, yagi antenna's. 
          The locations of the nearest cell towers (relative to where i live).
          After searching, listening, and reading on the subject, i concluded this is too much.
          Fortunately there is enough cellular signal to serve my family, but it left me considering my neighbors.
        </p> -->
      </article>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      concept1: "concept one, two, three",
      openComponent: [
        { name: "Action", visible: true },
        { name: "Experience", visible: false },
        { name: "Story", visible: false }
      ],
      openBox: 0
    }
  },
  mounted() {
    this.loadAccordion;
  },
  computed: {
    openComp() {
      console.log(this.openComponent);
      return this.openComponent;
    },
    innerWidth() {
      return window.innerWidth;
    },
    loadAccordion() {
      let allSegments = Object.keys(this.$refs);
      let self = this;
      let textSegments = allSegments.filter(ref => {
        if (ref !== "url") {
          return ref;
        }
      });
      console.log(textSegments)
      if (window.innerWidth <= 480) {
        textSegments.forEach((element, index) => {
          if (index === self.openBox) {
            self.$refs[element].style.display = "";
            self.openComponent[index].visible = true;
          } else {
            self.$refs[element].style.display = "none";
            self.openComponent[index].visible = false;
          }
        });
      } else {
        textSegments.forEach((element, index) => {
          self.$refs[element].style.display = "";
          self.openComponent[index].visible = true;
        });
      }
      return true;
    }
  },
  methods: {
    toggleAccordion(refr) {
      console.log(refr);
      let self = this;
      this.openComponent.forEach(element => {
        console.log(element)
        if (element.name === refr) {
          if (element.visible) {
            self.$refs[refr].style.display = "none";
            element.visible = false;
          } else {
            self.$refs[refr].style.display = "";
            element.visible = true;
          }
        } else {
          self.$refs[element.name].style.display = "none";
          element.visible = false;
        }
      });
    }
  }
};
</script>
<style lang="sass">
$font-stack:    Arial, sans-serif
$primary-color: #333

.content-p
  text-indent: 3ch
  whitespace: normal
  width: 80%
  word-wrap: normal
</style>
